import { InfoIcon } from 'lucide-react';
import React from 'react';

import AIBadge from '@/components/Badge/AIBadge/AIBadge';
import { Flex } from '@/components/base';
import TooltipV2 from '@/components/Tooltip/TooltipV2';
import { cn } from '@/lib/cn';

import type { CommonFieldProps } from './types';

export type PropertyRowConfig = CommonFieldProps & {
  children: React.ReactNode;
  className?: string;
  textClassName?: string;
  expandable?: boolean;
};
export const PropertyRowWrapper = (props: PropertyRowConfig) => {
  return (
    <div
      className={cn(
        'flex min-h-[36px] h-[36px] gap-[4px] items-center',
        props.expandable && 'items-start min-h-[36px] h-auto',
        props.className,
      )}
    >
      <div
        className={cn(
          'text-xs text-gray-600 vertical-align-baseline w-[140px] font-medium h-full py-2.5 flex items-center gap-1',
          props.textClassName,
        )}
      >
        <TooltipV2 tooltipNode={props.tooltip}>
          <span className="flex items-center gap-1">
            {props.label}
            {props.tooltip && <InfoIcon className="size-3.5 text-gray-600" />}
          </span>
        </TooltipV2>
        {props.ai_generated && <ModifiedAIBadge />}
      </div>
      <Flex className="flex py-1.5 items-center font-medium flex-1 gap-2">
        {props.children}
      </Flex>
    </div>
  );
};

const ModifiedAIBadge = () => (
  <AIBadge simple className="translate-x-0.5 inline-block text-sm" />
);
